import PreparatoryQuickEntryPage from './_PreparatoryQuickEntryPage'

export default function FinisherDFQuickEntryPage() {
  return <PreparatoryQuickEntryPage kind="finisher-df" />
}
